<block-ui>
  <div>
    <mat-card class="mb-25 tagus-card">
      <mat-card-header>
        <h5>{{ this.heading }}</h5>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="!hasData">
          No {{ this.heading.toLowerCase() }} to display
        </div>
        <div
          class="myTasksTable mat-elevation-z8 tagus-mat-table"
          [hidden]="!hasData"
        >
          <div class="row">
            <mat-form-field *ngIf="filter">
              <mat-label>Filter</mat-label>
              <input
                matInput
                (keyup)="applyFilter($event)"
                placeholder="Ex. Lobby"
                #input
              />
            </mat-form-field>
          </div>
          <table
            mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="announceSortChange($event)"
            class="table-scroll"
          >
            <ng-container
              *ngFor="let column of displayedColumnObjects"
              [matColumnDef]="column.id"
            >
              <ng-container *ngIf="column.cellTemplate">
                <th mat-header-cell *matHeaderCellDef>{{ column.title }}</th>
                <td mat-cell *matCellDef="let element">
                  <ng-template
                    [ngTemplateOutletContext]="{
                      element: element[column.id]
                    }"
                    [ngTemplateOutlet]="column.cellTemplate"
                  >
                  </ng-template>
                </td>
              </ng-container>

              <ng-container *ngIf="!column.cellTemplate">
                <th
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  class="text-start"
                >
                  {{ column.title }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-start">
                  <a
                    [routerLink]="getLink(column, element)"
                    *ngIf="column.link"
                  >
                    {{ element[column.id] }}
                  </a>
                  <span *ngIf="!column.link">
                    {{ element[column.id] }}
                  </span>
                </td>
              </ng-container>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
          </table>
          <mat-paginator
            [pageSize]="25"
            [pageSizeOptions]="[25, 50, 100]"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</block-ui>
